var elemental = require("../elem/elem.js");

export function multilevel(menu) {
  var elems = document.querySelectorAll(menu);



  elems.forEach(function (elem, index) {

   
    elem.childNodes.forEach(function (child, index) {

      // Child = LI
      let childlink = child.childNodes[0]


      if (childlink.classList) {
        if (childlink.classList.contains("menu-item-has-children")) {

          // Add Dropdown
            childlink.appendChild(
              elemental.elem('<span class="dropdown"></span>')
            );

            // Add Click Functionality
            childlink.addEventListener('click', (e) => {
              e.stopPropagation();
              e.preventDefault();
              
           

              elem.childNodes.forEach(function (childx, index) {
              
                  childx.childNodes[0].classList.remove('menu-active');
                
              });

              console.log('clicked');
              elem.classList.add('parent-menu-active');
              
              e.target.classList.add('menu-active');
    
            });

        }
      }
    });
  });


}
